module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_6000.964e5dcf.png";